import React from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { Building2, Users, Cpu } from "lucide-react";
import CompanyManagement from "./CompanyManagement";
import UserManagement from "./UserManagement";
import TenantManagement from "./TenantManagement";

const TABS = [
    { id: "companies", label: "Companies", icon: Building2, Component: CompanyManagement },
    { id: "users", label: "User Management", icon: Users, Component: UserManagement },
    { id: "tenants", label: "Tenant Management", icon: Cpu, Component: TenantManagement },
];

// Companies, User Management and Tenant Management on one page — ?tab= picks the section.
// Other query params (e.g. ?tenant= for User Management) are passed through untouched.
export default function ManagementHub() {
    const [params, setParams] = useSearchParams();
    const active = TABS.find(t => t.id === params.get("tab")) || TABS[0];
    const { Component } = active;

    return (
        <div>
            <div className="max-w-7xl mx-auto px-4 pt-2">
                <div className="flex gap-1 p-1 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl w-fit overflow-x-auto">
                    {TABS.map(({ id, label, icon: Icon }) => (
                        <button
                            key={id}
                            onClick={() => setParams({ tab: id })}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                                active.id === id
                                    ? "bg-navy-900 text-white"
                                    : "text-slate-500 hover:text-navy-900 hover:bg-slate-100 dark:hover:bg-slate-700 dark:hover:text-white"
                            }`}
                        >
                            <Icon size={15} /> {label}
                        </button>
                    ))}
                </div>
            </div>
            <Component key={active.id} />
        </div>
    );
}

// Old /companies, /users and /tenants routes → the matching tab, keeping any query params
export function ManagementRedirect({ base, tab }) {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    return <Navigate to={`${base}/management?${params}`} replace />;
}
